import { FormHelperText, MenuItem } from '@mui/material';
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import ApiService, { userCode, username } from '../../../services/ApiService';
import ButtonService from '../ButtonService';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CreateEditModalMaster from '../CreateEditModalMaster';
import { Input, Selection, showToast } from '../../../components/ui';

const CreateEditAirport = forwardRef((props, ref) => {
    const { isModal, handleClick, titleModal, title, param, selectedData, getData } = props

    const [cityList, setCityList] = useState([])
    const [countryList, setCountryList] = useState([])
    const [isLoading, setisLoading] = useState(true)

    useEffect(() => {
        console.log(selectedData)
        if (isModal) {
            getCountryData()

            if (selectedData?.id) {
                getCityById(selectedData.cityId)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isModal])

    const errorToast = (location, closeModal = false) => {
        showToast({ type: 'error', message: `Can't get ${location} data! please contact Administrator` })
        if (closeModal) handleClick()
    }

    const getCountryData = () => {
        ApiService.PostByPage('country/country', 1, 9999, [])
            .then((res) => {
                if (res.data.code === 200) {
                    setCountryList(res.data.data.country);
                } else {
                    errorToast('country', true)
                }

                if (!selectedData?.id) {
                    setisLoading(false)
                }
            }).catch(function (error) {
                errorToast('country', true)
            })
    }

    const getCityById = (cityId) => {
        if (!cityId) return

        ApiService.PostById('city/city', cityId).then((res) => {
            if (res?.data?.code === 200) {
                const cityResult = res.data.data.city
                formik.setFieldValue('countryId', cityResult.countryId)
                searchCityData(cityResult.countryId)
            } else {
                errorToast('city')
            }

            setisLoading(false)
        }).catch((error) => {
            console.log(error)
            errorToast('city')
        })
    }

    const searchCityData = (countryId) => {
        ApiService.CityPostBySearch('city/city', 1, 9999, countryId, []).then((res) => {
            if (res?.data?.code === 200) {
                setCityList(res.data.data.city)
            } else {
                errorToast('city')
            }
        }).catch((error) => {
            console.log(error)
            errorToast('city')
        })
    }

    const simpanLocal = () => {
        if (isModal) {
            const data = {
                "airPort": {
                    ...formik.values,
                    rowStatus: formik?.values?.rowStatus || 'ACT',
                    titleModal,
                    userCode,
                }
            }
            localStorage.setItem(username + "-DataAirport", JSON.stringify(data));
        }
    }

    useImperativeHandle(ref, () => ({

        localSave() {
            simpanLocal()
        }

    }));

    const validationSchema = Yup.object().shape({
        masterCode: Yup.string().nullable(),
        code: Yup.string().trim().required('This field is required.'),
        abbreviation: Yup.string().nullable(),
        airPortName: Yup.string().trim().required('This field is required.'),
        countryId: Yup.number().required('This field is required.'),
        cityId: Yup.number().required('This field is required.'),
    })

    const formik = useFormik({
        initialValues: selectedData?.id ? {
            ...selectedData,
            code: selectedData?.code || '',
            countryId: '',
            cityId: selectedData?.cityId !== 0 ? selectedData.cityId : ''
        } : {
            masterCode: '',
            code: '',
            abbreviation: '',
            airPortName: '',
            countryId: '',
            cityId: '',
        },
        validationSchema,
        onSubmit: (values) => Save(values)
    })

    const Save = (payload) => {
        if (payload?.cityId === '') {
            return showToast({ type: 'error', message: 'City is Required!' });
        }

        if (payload?.airPortName === '') {
            return showToast({ type: 'error', message: 'Airport Name is Required!' });
        }

        const data = {
            "airPort": {
                "rowStatus": payload?.rowStatus || "ACT",
                "id": payload?.id,
                "code": payload?.code,
                "name": payload?.airPortName,
                "abbreviation": payload?.abbreviation,
                "masterCode": payload?.masterCode,
                "cityId": payload?.cityId,
                "user": userCode
            }
        }

        ButtonService.Save(titleModal, title, param, data, () => {
            getData(1, 50, []);
            handleClick();
        });
    }

    const mainContainer = (
        <form onSubmit={formik.handleSubmit} style={{ marginTop: '12px' }}>
            <Input
                name="masterCode"
                label={'Master Code'}
                value={formik.values.masterCode}
                disabled
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('masterCode', e.target.value)}
                error={formik.touched.masterCode && Boolean(formik.errors.masterCode)}
                helperText={formik.touched.masterCode && formik.errors.masterCode}
                formControlProps={{
                    sx: {
                        width: '100%',
                        // marginTop: '16px'
                    }
                }}
            />

            <Input
                name="code"
                label={'Code'}
                value={formik.values.code}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('code', e.target.value)}
                error={formik.touched.code && Boolean(formik.errors.code)}
                helperText={formik.touched.code && formik.errors.code}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            />

            <Selection
                id="country"
                name='countryId'
                fullWidth={true}
                labelId="lblCountry"
                placeholder={'Select Country'}
                value={formik.values.countryId}
                label="Country"
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                onChange={(e) => {
                    formik.setFieldValue('countryId', e.target.value)
                    formik.setFieldValue('cityId', '')
                    searchCityData(e.target.value)
                }}
                error={formik.touched.countryId && Boolean(formik.errors.countryId)}
            >
                {
                    countryList.map((country) => (
                        <MenuItem sx={{ fontSize: '12px' }} key={country.id} value={country.id}>{country.name}</MenuItem>
                    ))
                }
                <FormHelperText>{formik.touched.countryId && formik.errors.countryId}</FormHelperText>
            </Selection>

            <Selection
                id="city"
                name='cityId'
                labelId="lblCity"
                label="City"
                fullWidth={true}
                placeholder={'Select City'}
                value={formik.values.cityId}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                error={formik.touched.cityId && Boolean(formik.errors.cityId)}
                onChange={(e) => formik.setFieldValue('cityId', e.target.value)}
            >
                {
                    cityList.map((city) => (
                        <MenuItem sx={{ fontSize: '12px' }} key={city.id} value={city.id}>{city.name}</MenuItem>
                    ))
                }
                <FormHelperText>{formik.touched.cityId && formik.errors.cityId}</FormHelperText>
            </Selection>

            <Input
                label={'Airport'}
                name="airPortName"
                value={formik.values.airPortName}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('airPortName', e.target.value)}
                error={formik.touched.airPortName && Boolean(formik.errors.airPortName)}
                helperText={formik.touched.airPortName && formik.errors.airPortName}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            />

            <Input
                name="abbreviation"
                label={'Abbreviation'}
                value={formik.values.abbreviation}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('abbreviation', e.target.value)}
                error={formik.touched.abbreviation && Boolean(formik.errors.abbreviation)}
                helperText={formik.touched.abbreviation && formik.errors.abbreviation}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            />
        </form>
    )

    return (
        <>
            {
                isModal && (
                    <CreateEditModalMaster
                        isModal={isModal}
                        titleModal={titleModal}
                        title={title}
                        isLoading={isLoading}
                        mainContainer={mainContainer}
                        handleClick={handleClick}
                        handleSave={() => Save(formik.values)}
                    />
                )
            }
        </>
    )
})

export default CreateEditAirport